import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useActionRequiredInvoices from 'src/hooks/useActionRequiredInvoices';

const GLCodeField: FC<GridCellProps> = (props) => {
  const { setAdditionalGLCodeFilter, setSelectedGLSummaryRowId } = useActionRequiredInvoices();
  const { dataItem, field = '' } = props;

  const value = useMemo(() => dataItem?.[field], [dataItem, field]);

  const rowId = useMemo(() => dataItem?.rowId, [dataItem?.rowId]);

  const handleClick = useCallback(() => {
    setAdditionalGLCodeFilter(value);
    setSelectedGLSummaryRowId(rowId);
  }, [rowId, setAdditionalGLCodeFilter, setSelectedGLSummaryRowId, value]);

  return (
    <GridCellBase {...props} title={value}>
      <u className="cursor-pointer text-blue-700" onClick={handleClick}>
        {value}
      </u>
    </GridCellBase>
  );
};

export default GLCodeField;
